import {
  useMutation,
  UseMutationOptions,
  useQueryClient,
} from '@tanstack/react-query'
import { taskTemplateKeys } from '../taskTemplateKeys'
import { RequestTypes } from '../requestTypes'
import { foldersKeys } from '@core/react-query/features/folders'
import { RequestErrorType } from '@core/utils/api-axios-instance'

export const useArchiveTaskTemplate = (
  options?: UseMutationOptions<
    unknown,
    RequestErrorType,
    RequestTypes['archiveTaskTemplate']
  >,
) => {
  const queryClient = useQueryClient()
  return useMutation({
    ...taskTemplateKeys.archiveTaskTemplate,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: taskTemplateKeys._def })
      queryClient.invalidateQueries({ queryKey: foldersKeys._def })
    },
    ...options,
  })
}
